import React from 'react';
// @material-ui/core components
// @material-ui/icons
import Warning from "@material-ui/icons/Warning";
// core components
import SnackbarContent from "vendor/components/Snackbar/SnackbarContent.jsx";
import Clearfix from "vendor/components/Clearfix/Clearfix.jsx";
import classes from './ErrorModal.css'

const errorModal = (props) => (

    props.show ?
        <div className={classes.container}>
            <SnackbarContent
                message={
                    <span>
                        {props.text}
                    </span>
                }
                close
                closeNotification={() => props.closeClick()}
                color="danger"
                icon={Warning}
            />
            <Clearfix />
        </div> : null
);


export default errorModal;